"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _microphone = _interopRequireDefault(require("@atlaskit/icon/core/microphone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VidAudioOnIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="6" height="12" x="9" y="3" rx="3"/><path fill-rule="nonzero" d="M13 17.917c2.833-.476 5-2.941 5-5.91V9a1 1 0 0 0-2 0v3.006A4 4 0 0 1 12 16c-2.205 0-4-1.795-4-3.994V9a1 1 0 1 0-2 0v3.006c0 2.96 2.162 5.433 5 5.91v2.075a1 1 0 1 0 2 0z"/></g></svg>`
}, props, {
  newIcon: _microphone.default
}));
VidAudioOnIcon.displayName = 'VidAudioOnIcon';
var _default = exports.default = VidAudioOnIcon;